
// import React, { useEffect, useRef, useState } from 'react';
// import mapboxgl from 'mapbox-gl';
// import 'mapbox-gl/dist/mapbox-gl.css';
// import { MAPBOX_ACCESS_TOKEN } from 'src/constants/Defaultvalues';
// import homeIcon from '../../../src/assets/active-routes-home.png';

// mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;

// const toBool = (v) => v === true || v === 'true' || v === 1 || v === '1';

// /* ------------------------------------------------------------------ */
// /* helper that renders the numbered, colour-coded marker dot          */
// /* ------------------------------------------------------------------ */
// const createNumberDot = (fill, label, isStart, isEnd) => {
//   const el = document.createElement('div');

//   el.textContent     = label;
//   el.style.width     = '28px';
//   el.style.height    = '28px';
//   el.style.borderRadius = '50%';
//   el.style.font      = '600 12px/28px sans-serif';
//   el.style.textAlign = 'center';
//   el.style.cursor    = 'pointer';
//   el.style.color     = '#fff';

//   if (isStart && isEnd) {
//     /* split green / red — start + end on same point */
//     el.style.background =
//       'linear-gradient(to right, #6dd406 50%, #ed0e25 50%)';
//   } else {
//     el.style.backgroundColor = fill;
//   }
//   return el;
// };

// /* ================================================================== */
// /*                               COMPONENT                            */
// /* ================================================================== */
// const MapBoxComponent = ({
//   markers = [],
//   home = null,
//   directions = null,
//   onMarkerHover,
//   onMarkerLeave,
//   onMarkerClick,
//   onMarkerDragEnd,
// }) => {
//   const mapContainerRef = useRef(null);
//   const mapRef          = useRef(null);
//   const markerRefs      = useRef([]);
//   const hasAutoZoomed   = useRef(false);   // ➊ stop further fitBounds()
//   const [styleReady, setStyleReady] = useState(false);


//   useEffect(() => {
//     if (mapRef.current) return;            // already initialised

//     const map = new mapboxgl.Map({
//       container: mapContainerRef.current,
//       style   : 'mapbox://styles/mapbox/streets-v11',
//       center  : home?.lng && home?.lat
//                 ? [home.lng, home.lat]
//                 : [-111.7589043, 32.8796404],
//       zoom    : 10,
//     });

//     map.addControl(new mapboxgl.NavigationControl(), 'top-right');
//     // map.addControl(new mapboxgl.FullscreenControl(), 'top-right');

//     map.on('load', () => setStyleReady(true));

//     /* ➋ the first time the user zooms or drags, disable further auto-fit */
//     map.once('zoomstart', () => { hasAutoZoomed.current = true; });
//     map.once('dragstart', () => { hasAutoZoomed.current = true; });

//     mapRef.current = map;
//     return () => map.remove();
//   }, [home?.lat, home?.lng]);

//   /* -------------------------------------------------------------- */
//   /* 2️⃣ draw / update the route poly-line & arrows                  */
//   /* -------------------------------------------------------------- */
//   useEffect(() => {
//     if (!styleReady || !mapRef.current) return;

//     const map = mapRef.current;

//     /* remove previous layers if present */
//     ['route-arrows', 'route'].forEach(
//       (id) => map.getLayer(id) && map.removeLayer(id)
//     );
//     map.getSource('route') && map.removeSource('route');

//     /* nothing to draw? */
//     if (
//       !directions ||
//       directions.type !== 'LineString' ||
//       !Array.isArray(directions.coordinates) ||
//       directions.coordinates.length < 2
//     ) {
//       return;
//     }

//     /* add the geojson line */
//     map.addSource('route', {
//       type: 'geojson',
//       data: { type: 'Feature', geometry: directions },
//     });
//     map.addLayer({
//       id: 'route',
//       type: 'line',
//       source: 'route',
//       layout: { 'line-cap': 'round', 'line-join': 'round' },
//       paint : { 'line-color': '#00AEEF', 'line-width': 4 },
//     });

//     /* arrow symbols along the line */
//     if (!map.hasImage('arrow-icon')) {
//       const img = new Image(20, 20);
//       img.onload = () =>
//         !map.hasImage('arrow-icon') && map.addImage('arrow-icon', img);
//       img.src =
//         'data:image/svg+xml;charset=utf-8,' +
//         encodeURIComponent(`
//           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
//                fill="#00AEEF" viewBox="0 0 24 24">
//             <path d="M12 2L10.59 3.41 17.17 10H2v2h15.17l-6.58 6.59L12 22l10-10z"/>
//           </svg>`);
//     }
//     map.addLayer({
//       id: 'route-arrows',
//       type: 'symbol',
//       source: 'route',
//       layout: {
//         'symbol-placement'      : 'line',
//         'symbol-spacing'        : 60,
//         'icon-image'            : 'arrow-icon',
//         'icon-size'             : 1,
//         'icon-allow-overlap'    : true,
//         'icon-ignore-placement' : true,
//         'icon-rotation-alignment': 'map',
//       },
//     });

//     /* fit only the first time (unless the user already moved the map) */
//     if (!hasAutoZoomed.current) {
//       const bounds = directions.coordinates.reduce(
//         (b, [lng, lat]) => b.extend([lng, lat]),
//         new mapboxgl.LngLatBounds(
//           directions.coordinates[0],
//           directions.coordinates[0]
//         )
//       );
//       map.fitBounds(bounds, { padding: 60 });
//       hasAutoZoomed.current = true;
//     }
//   }, [directions, styleReady]);

//   /* -------------------------------------------------------------- */
//   /* 3️⃣ draw / update all markers                                   */
//   /* -------------------------------------------------------------- */
//   useEffect(() => {
//     if (!styleReady || !mapRef.current) return;

//     const map = mapRef.current;

//     /* clear old markers */
//     markerRefs.current.forEach((m) => m.remove());
//     markerRefs.current = [];

//     const bounds = new mapboxgl.LngLatBounds();

//     /* 3.1 HOME marker */
//     if (home?.lat && home?.lng) {
//       const el = document.createElement('div');
//       el.style.cssText =
//         `width:28px;height:28px;background:url(${homeIcon}) center/contain no-repeat;`;
//       const hm = new mapboxgl.Marker(el)
//         .setLngLat([home.lng, home.lat])
//         .addTo(map);

//       markerRefs.current.push(hm);
//       bounds.extend([home.lng, home.lat]);
//     }

//     /* 3.2 dynamic markers */
//     markers.forEach((mData) => {
//       const { latitude, longitude } = mData;
//       if (latitude == null || longitude == null) return;

//       const isStart = toBool(mData.starting_point);
//       const isEnd   = toBool(mData.ending_point);
//       const label   = mData.index;
//       const fill    = isStart
//                         ? '#6dd406'
//                         : isEnd
//                           ? '#ed0e25'
//                           : mData.color || '#1976d2';

//       const el = createNumberDot(fill, label, isStart, isEnd);

//       /* hover, leave, click handlers */
//       el.addEventListener('mouseenter', (e) =>
//         onMarkerHover?.(mData.raw || mData, { x: e.clientX, y: e.clientY })
//       );
//       el.addEventListener('mouseleave', () => onMarkerLeave?.());
//       el.addEventListener('click', (e) => {
//         e.stopPropagation();
//         onMarkerClick?.(mData.raw || mData, { x: e.clientX, y: e.clientY });
//       });

//       const mk = new mapboxgl.Marker({
//         element  : el,
//         draggable: !!onMarkerDragEnd,
//       })
//         .setLngLat([longitude, latitude])
//         .addTo(map);

//       if (onMarkerDragEnd) {
//         mk.on('dragend', () => {
//           const { lng, lat } = mk.getLngLat();
//           // const key          = mData.raw?.location_id
//           //                   ?? mData.raw?.id
//           //                   ?? mData.index;

//          const key          = mData.index;
//           onMarkerDragEnd({ lat, lng }, key, mData.raw ?? mData);
//         });
//       }

//       markerRefs.current.push(mk);
//       bounds.extend([longitude, latitude]);
//     });

//     /* auto-fit only once, and only when we have no route yet */
//     if (!bounds.isEmpty() && !directions && !hasAutoZoomed.current) {
//       map.fitBounds(bounds, { padding: 60 });
//       hasAutoZoomed.current = true;
//     }
//   }, [
//     markers,
//     home,
//     styleReady,
//     directions,
//     onMarkerHover,
//     onMarkerLeave,
//     onMarkerClick,
//     onMarkerDragEnd,
//   ]);

//   /* -------------------------------------------------------------- */
//   /* render container                                               */
//   /* -------------------------------------------------------------- */
//   return (
//     <div style={{ width: '100%', height: '600px' }}>
//       <div ref={mapContainerRef} style={{ width: '100%', height: '100%' }} />
//     </div>
//   );
// };

// export default MapBoxComponent;


import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import ReactDOM from 'react-dom';
import { MAPBOX_ACCESS_TOKEN } from 'src/constants/Defaultvalues';
import homeIcon from '../../../src/assets/active-routes-home.png';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { Close } from '@material-ui/icons';
import Slider from 'react-slick';

mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;

const toBool = (v) => v === true || v === 'true' || v === 1 || v === '1';

const createNumberDot = (fill, label, isStart, isEnd) => {
  const el = document.createElement('div');
  el.textContent = label;
  el.style.width = '28px';
  el.style.height = '28px';
  el.style.borderRadius = '50%';
  el.style.font = '600 12px/28px sans-serif';
  el.style.textAlign = 'center';
  el.style.cursor = 'pointer';
  el.style.color = '#fff';

  if (isStart && isEnd) {
    el.style.background = 'linear-gradient(to right, #6dd406 50%, #ed0e25 50%)';
  } else {
    el.style.backgroundColor = fill;
  }
  return el;
};

const PopupCard = ({ data, onClose, onSetPoint,sliderSettings }) => {
  console.log("datadata---",data);
  data['attachments'] = data?.attachments?.length
                          ? data?.attachments
                          : data?.service_image
                          ? [{ name: data?.service_image }]
                          : []
  return(
  <Box sx={{ width: 220, p: 1, position: 'relative',backgroundColor:"#00191e" }} 
    onMouseLeave={() => onClose()}>
    <IconButton
      size="small"
      sx={{ position: 'absolute', top: 4, right: 4, color: '#fff' }}
      onClick={onClose}
    >
      <Close fontSize="small" />
    </IconButton>

    {/* {data?.attachments?.length > 0 && (
      <Box
        component="img"
        src={data.attachments[0]?.name}
        alt="Image"
        sx={{ width: '100%', height: 120, objectFit: 'cover', mb: 1 }}
      />
    )} */}
     {data?.attachments?.length > 0 && (
                <Slider {...sliderSettings}>
                  {data.attachments.map((attachment, i) => (
                    <Box
                      key={i}
                      component="img"
                      src={attachment.name}
                      alt="Design"
                      sx={{ width: '100%', height: 120, objectFit: 'cover' }}
                    />
                  ))}
                </Slider>
              )}
    <Typography variant="subtitle1" fontWeight="bold">{data?.productName}</Typography>
    <Typography variant="body2">📍 {data?.wholeAddress || 'Location'}</Typography>
    <Typography variant="body2">📦 Quantity: {data?.quantity || 1}</Typography>

    <Box sx={{ mt: 1 }}>
      <Typography variant="body2" fontWeight={600}>Choose an option:</Typography>
      <Button variant="outlined" size="small" fullWidth sx={{ my: 0.5 }} onClick={() => onSetPoint('start', data)}>Set as Start</Button>
      <Button variant="outlined" size="small" fullWidth sx={{ my: 0.5 }} onClick={() => onSetPoint('end', data)}>Set as End</Button>
      <Button variant="outlined" size="small" fullWidth sx={{ my: 0.5 }} onClick={() => onSetPoint('both', data)}>Set as Both</Button>
      <Button variant="outlined" size="small" fullWidth color="secondary" sx={{ my: 0.5 }} onClick={() => onSetPoint('remove', data)}>Remove Start/End</Button>
    </Box>
  </Box>
)};

const MapBoxComponent = ({
  markers = [],
  home = null,
  directions = null,
  onMarkerClick,
  onMarkerDragEnd,
  onSetPoint,
  hasRouteMovingPermission,
  sliderSettings
}) => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const markerRefs = useRef([]);
  const popupRef = useRef(null);
  const hasAutoZoomed = useRef(false);
  const [styleReady, setStyleReady] = useState(false);

  
  console.log('markersmarkers', markers)

  useEffect(() => {
    if (mapRef.current) return;

    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: home?.lng && home?.lat ? [home.lng, home.lat] : [-111.7589, 32.8796],
      zoom: 10,
    });

    map.addControl(new mapboxgl.NavigationControl(), 'top-right');
    map.addControl(new mapboxgl.FullscreenControl(), 'top-right');
    map.on('load', () => setStyleReady(true));
    map.once('zoomstart', () => { hasAutoZoomed.current = true; });
    map.once('dragstart', () => { hasAutoZoomed.current = true; });

    mapRef.current = map;
    return () => map.remove();
  }, [home?.lat, home?.lng]);

  useEffect(() => {
    if (!styleReady || !mapRef.current) return;
    const map = mapRef.current;

    ['route-arrows', 'route'].forEach((id) => map.getLayer(id) && map.removeLayer(id));
    map.getSource('route') && map.removeSource('route');

    if (!directions || directions.type !== 'LineString' || !Array.isArray(directions.coordinates)) return;

    map.addSource('route', {
      type: 'geojson',
      data: { type: 'Feature', geometry: directions },
    });

    map.addLayer({
      id: 'route',
      type: 'line',
      source: 'route',
      layout: { 'line-cap': 'round', 'line-join': 'round' },
      paint: { 'line-color': '#00AEEF', 'line-width': 4 },
    });

    if (!map.hasImage('arrow-icon')) {
      const img = new Image(20, 20);
      img.onload = () => !map.hasImage('arrow-icon') && map.addImage('arrow-icon', img);
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
             fill="#00AEEF" viewBox="0 0 24 24">
          <path d="M12 2L10.59 3.41 17.17 10H2v2h15.17l-6.58 6.59L12 22l10-10z"/>
        </svg>`);
    }

    map.addLayer({
      id: 'route-arrows',
      type: 'symbol',
      source: 'route',
      layout: {
        'symbol-placement': 'line',
        'symbol-spacing': 60,
        'icon-image': 'arrow-icon',
        'icon-size': 1,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'icon-rotation-alignment': 'map',
      },
    });

    if (!hasAutoZoomed.current) {
      const bounds = directions.coordinates.reduce(
        (b, [lng, lat]) => b.extend([lng, lat]),
        new mapboxgl.LngLatBounds(directions.coordinates[0], directions.coordinates[0])
      );
      map.fitBounds(bounds, { padding: 60 });
      hasAutoZoomed.current = true;
    }
  }, [directions, styleReady]);

  useEffect(() => {
    if (!styleReady || !mapRef.current) return;
    const map = mapRef.current;

    markerRefs.current.forEach((m) => m.remove());
    markerRefs.current = [];

    const bounds = new mapboxgl.LngLatBounds();

    if (home?.lat && home?.lng) {
      const el = document.createElement('div');
      el.style.cssText = `width:28px;height:28px;background:url(${homeIcon}) center/contain no-repeat;`;
      const hm = new mapboxgl.Marker(el).setLngLat([home.lng, home.lat]).addTo(map);
      markerRefs.current.push(hm);
      bounds.extend([home.lng, home.lat]);
    }

    markers.forEach((mData) => {
      const { latitude, longitude } = mData;
      if (latitude == null || longitude == null) return;

      const isStart = toBool(mData.starting_point);
      const isEnd = toBool(mData.ending_point);
      const label = mData.index;
      const fill = isStart ? '#6dd406' : isEnd ? '#ed0e25' : mData.color || '#1976d2';

      const el = createNumberDot(fill, label, isStart, isEnd);

      el.addEventListener('click', (e) => {
        e.stopPropagation();
        if (popupRef.current) popupRef.current.remove();

        const container = document.createElement('div');
        ReactDOM.render(
          <PopupCard
            data={mData.raw ?? mData}
            onClose={() => popupRef.current?.remove()}
            onSetPoint={(type, location) => {
              onSetPoint?.(type, location);
              popupRef.current?.remove();
            }}
            sliderSettings={sliderSettings}
          />,
          container
        );

        popupRef.current = new mapboxgl.Popup({ offset: 15, closeButton: false })
          .setDOMContent(container)
          .setLngLat([longitude, latitude])
          .addTo(map);
      });

      const mk = new mapboxgl.Marker({
        element: el,
        draggable: hasRouteMovingPermission,
      })
        .setLngLat([longitude, latitude])
        .addTo(map);

      if (onMarkerDragEnd) {
        mk.on('dragend', () => {
          const { lng, lat } = mk.getLngLat();
          const key = mData.index;
          onMarkerDragEnd({ lat, lng }, key, mData.raw ?? mData);
        });
      }

      markerRefs.current.push(mk);
      bounds.extend([longitude, latitude]);
    });

    if (!bounds.isEmpty() && !directions && !hasAutoZoomed.current) {
      map.fitBounds(bounds, { padding: 60 });
      hasAutoZoomed.current = true;
    }
  }, [markers, home, styleReady, directions, onMarkerClick, onMarkerDragEnd]);

  return (
    <div style={{ width: '100%', height: '600px' }}>
      <div ref={mapContainerRef} style={{ width: '100%', height: '100%' }} />
    </div>
  );
};

export default MapBoxComponent;
